import { Loader, Tooltip } from '@/components/ui'
import { formatNumber } from '@/utils'

interface ReservedCreditsIndicatorProps {
  reserved: number
  className?: string
}

export const ReservedCreditsIndicator = ({
  reserved,
  className,
}: ReservedCreditsIndicatorProps) => {
  if (!reserved) return null

  return (
    <Tooltip
      content={`This balance already accounts for ${formatNumber(reserved)} credits held by in-progress statements.`}
    >
      <span className="inline-flex">
        <Loader size="sm" className={className} />
      </span>
    </Tooltip>
  )
}
